const translations = {
    label: 'Product Usage Report (Created on {{createdOn}} for {{contact}} at {{siteName}})',
    tbd: 'TBD'
};

export default translations;
